import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material';
import { CalendarioPickerComponent } from '../calendario-picker/calendario-picker.component';
import * as moment from 'moment';

@Component({
  selector: 'app-data-picker',
  templateUrl: './data-picker.component.html',
})
export class DataPickerComponent {

  @Input() placeholder;
  
  _data;
 
  @Output() dataChanged = new EventEmitter();

  dataFormatada = "";

  constructor(public dialog: MatDialog){
  }
  @Input() 
  set data(data){
    this._data = data;
    this.format();
  }

  get model(){
    return this.data;
  }
  
  set model(_data){
    this._data = _data;
    this.dataChanged.emit(_data);

    this.format();
  }

  format(){
    if(this._data){
      this.dataFormatada = moment(this._data).format("DD/MM/YYYY");
    }else{
      this.dataFormatada = "";
    }
  }

  abrirCalendario(){
    const dialogRef = this.dialog.open(CalendarioPickerComponent, {
      width: '400px',
      height: '550px',
    });

    dialogRef.afterClosed().subscribe(
      (dados) => {
        if(dados && dados.dataSelecionada){
          //Ver como funcionada
          this.model = dados.dataSelecionada;
        }
      }
    )
  }
  limparCalendario(){
    this.model = undefined;
  }
}
